<template>
    <div class="page">
        <div class="main_body">
            <div class="top_label">
                <span class="lable_name">班级管理</span>
                <el-input
                    placeholder="请输入班级名称"
                    style="width: 300px;"
                    @input="changKeyword"
                    v-model="keyword">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
            </div>
            <div class="plan-grid-container">

                <div v-for="(item,index) in plan_data" :key="index" class="plan-grid-item">
                    <div class="top_image">
                        <img src="../../../static/image/plan_icon.png" />
                    </div>
                    <div class="plan_info_box">
                        <div class="plan_name_box">
                            <span class="left">{{ item.name }}</span>
                            <span class="right">{{ item.status?'独立班':'自然班' }}</span>
                        </div>
                        <span class="plan_info_list">
                            
                            年级：{{ item.grade_text }} 学院：{{ item.college }}
                        </span>
                        <span class="plan_info_list">
                            
                            老师：{{ item.u_id_text }}
                        </span>
                        <span class="plan_info_list">
                            
                            人数：{{ item.number }}人
                        </span>
                        <span class="plan_info_list">
                            
                            班级码：{{ item.qcode }}
                        </span>
                    </div>
                    <div class="plan_button_box">
                        <el-button @click="planDetail(item.plan_id)" size="large" type="primary">查看班级</el-button>
                        
                        <span @click="open(item.id)" class="MoreFilledbox">
                            <i class="el-icon-delete"></i>
                        </span>
                        
                    </div>
                </div>
                <div style="postion:relative;border:2px dashed #e5e7eb" class="plan-grid-item">
                    <div class="plan_add_box">
                        
                        <i class="el-icon-message-solid"></i>
                    </div>
                    <span class="plan_add_info" style="font-weight: 700;">暂无更多班级</span>
                    <span style="font-size:14px;color:#6b7280" class="plan_add_info">点击下方按钮加入新班级开始学习</span>

                    <el-button @click="dialogFormVisible = true" class="add_button" size="large" type="primary"> <el-icon size="15" style="margin-right:5px"><Plus /></el-icon>加入班级</el-button>
                </div>
            </div>
        </div>
        <div class="dialog_">
            <el-dialog title="加入班级" width="50%" :visible.sync="dialogFormVisible">
                <el-form :model="form">
                    <el-form-item label="" :label-width="formLabelWidth">
                        <el-input v-model="form.qcode" @input="serachPlan" size="small" placeholder="输入班级码"></el-input>
                    </el-form-item>
                    
                </el-form>
                
                <el-table size="medium" :data="tableData" style="width: 100%">
                    <el-table-column
                        prop="name"
                        label="班级名称"
                        width="260">
                    </el-table-column>
                    <el-table-column
                        prop="u_id_text"
                        label="管理员">
                    </el-table-column>
                    <el-table-column
                        prop="grade_text"
                        label="年级">
                    </el-table-column>
                    <el-table-column
                        prop="college"
                        label="学院">
                    </el-table-column>
                    <el-table-column
                        prop="specialty"
                        label="专业">
                    </el-table-column>
        
                    <el-table-column label="操作">
                        <template slot-scope="scope">
    
                            <el-button
                            size="mini"
                            type="primary"
                            @click="pushPlan(scope.row.plan_id)">加入</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-dialog>
        </div>
    </div>
</template>
  
<script>
    import Http from "../../apis/student";
    import skeleton from "../../../untils/skeleton.vue";
    export default{
        components:{
            'Skeleton':skeleton
        },
        data(){

            return{
                variant:'image',
                activeName:'first',
                dialogFormVisible:false,
                dialogImageUrl:false,
                form:{
                    qcode:''
                },
                formLabelWidth:'0px',
                tableData: [],
                dialogVisible:false,
                addformLabelWidth:'3vw',
                keyword:'',
                plan_data:[],
                loading:true
            }
        },
        created(){
            this.getPlan()
        },
        activated(){
            //this.getPlan()
            window.addEventListener('popstate', this.handlePopState());
        },
        methods:{
            handlePopState(){
                document.body.style.overflow = 'auto';
            },
            // 获取班级
            getPlan(){
                // const loading = this.$loading({
                //     lock: true,
                //     text: '疯狂加载中..',
                //     spinner: 'el-icon-loading',
                //     background: 'rgba(0, 0, 0, 0.5)'
                // });
                var params = {}
                params.keyword = this.keyword
                Http.Plan(params).then((res) => {
                    this.loading = false
                    //loading.close()
                    this.plan_data = res.data
                });

            },

            open(plan_id) {
                this.$confirm('此操作将退出该班级, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'error'
                }).then(() => {
                    this.quitPlan_(plan_id)
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
                });
            },


            // 退出班级
            quitPlan_(plan_id){

                var params = {}
                params.plan_id = plan_id
                Http.quitPlan(params).then((res) => {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: res.code ? 'success' : 'error'
                    });
                    if(res.code){
                        this.$router.back();
                    }
                });
            },

            // 搜索班级
            changKeyword(){
                this.getPlan()
            },

            // 班级码搜索班?
            serachPlan(){

                Http.searchPlan(this.form).then((res) => {
                    this.tableData = res.data
                });
            },
            // 加入班级
            pushPlan(plan_id){
                var params = {}
                params.plan_id = plan_id
                Http.pushPlan(params).then((res) => {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: res.code ? 'success' : 'error'
                    });
                    if(res.code){
                        this.dialogFormVisible = false
                        this.getPlan()
                    }
                });
            },

            planDetail(plan_id){

                var _this = this
                _this.$router.push({name:'StudentPlanDetail',query:{plan_id:plan_id}});
            }

        }
    }

</script>

<style scoped>
    .lable_name{
        font-size: 20px;
        font-weight: bold;
    }
    .main_body{
        padding: 20px;
        background: #fff;
        border-radius: 8px;
    }
    .paln_page >>> .el-main{
        background: #ffffff !important;
        margin: 20px;
        border-radius: 8px;
    }
    .top_label{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .main_body >>> .el-tabs__item{
        font-size: 16px;
    }
    .main_body >>> p{
        text-align: left;
    }
    .search{
        margin-left: 15px;
    }
    .main_body >>>.el-card__body{
        float: left;
        width: 100%;
        padding-right: 25px;
        box-sizing: border-box;
    }
    .list_right >>> i{
        float: right;
        margin-left: 10px;
        font-size: 18px;
    }

    .main_body >>> .el-col{
        margin-bottom: 20px;
    }
    .serach >>> .el-input{
        width: 10vw;
        float: left;
    }
    .dialog_ >>> .el-input{
        width: 50%;
        float: left;
    }
    .dialog_ >>> .el-dialog{
        border-top-left-radius: 11px;
        border-top-right-radius: 11px;
    }
    .dialog_ >>> .search_button{
        float: left;
        margin-left: 10px;
    }
    .dialog_ >>> .el-dialog__header{

        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
    }

    .dialog_add >>> .el-form{
        width: 60%;
        margin: 0 auto;
    }
    .dialog_add >>> .el-select{
        width: 100%;
    }

 .plan-grid-container {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 30px; /* 设置间距为20px */
    width: 100%;
    margin-top: 30px;
}

.plan-grid-item {
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.15);
    transition: transform 0.3s ease;
}
.plan-grid-item:hover {
    transform: translateY(-10px);
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.15);
}

.top_image{
    width:100%;
    height:192px;    
    background-image: linear-gradient(to bottom right, rgb(64 158 255 / 0.3) , rgb(64 158 255 / 0.1));
    position: relative;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}
.top_image img {
    width: 90px;
    height: 60px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.plan_info_box{
    width: 100%;
    display: inline-block;
    box-sizing: border-box;
    padding: 15px;
}
.plan_name_box{
    width: 100%;
    display: inline-block;
    margin-bottom: 10px;
}
.plan_name_box .left{
    font-size: 18px;
    font-weight: 700;
    color: #000000;
    float: left;
}
.plan_name_box .right{
    font-size: 12px;
    color: #000000;
    float: right;
    padding: 5px 10px;
    background: #DCFCE7;
    color: #166534;
    border-radius: 20px;
}
.plan_info_list{
    width: 100%;
    display: inline-block;
    text-align: left;
    margin-bottom: 10px;
    font-size: 14px;
}
.plan_info_list :deep(.el-icon){
    float: left;
    margin-right: 5px;
}
.plan_button_box{
    width: 100%;
    display: inline-block;
    box-sizing: border-box;
    padding: 15px;
}
.plan_button_box :deep(.el-button){
    width: calc(100% - 50px);
    float: left ;
}
.MoreFilledbox{
    float: right;
    border: 1px #e5e7eb solid;
    padding: 7px 10px;
    border-radius: 5px;
    cursor: pointer;
}
.MoreFilledbox:hover{
    color: #FF523F;
}
.MoreFilledbox >>> .el-icon-delete{
    font-size: 22px;
}
.plan_add_box{
    background: #F3F4F6;
    border-radius: 50%;
    width: 100px;
    height: 100px;
    margin: 0 auto;
    line-height: 114px;
    margin-top:50px;
}
.plan_add_info{
    width: 100%;
    display: inline-block;
    text-align: center;
    box-sizing: border-box;
    padding: 0px 20px;
    margin-top: 20px;
}
.add_button{
    margin-top: 40px;
    margin-bottom: 139px;
}
.plan_tage{
    position: absolute;
    width: 60px !important;
    height: 38px !important;
    left: 0;
}
.plan_add_box >>> .el-icon-message-solid{
    font-size: 34px;
    color: #9CA3AF;
}
</style>
<style lang="less" scoped>
@import url('../../../static/css/main.less');
</style>